import {useCallback, useEffect, useRef, useState} from 'react';

export function useLazyImport<T>(
  moduleImport: () => Promise<{default: T} | T>,
  extractor?: (module: {default: T} | T) => T,
) {
  const lazyModuleRef = useRef<T | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (lazyModuleRef.current) return;
    moduleImport().then(module => {
      lazyModuleRef.current = extractor
        ? extractor(module)
        : (module as {default: T})?.default;
      setIsLoaded(true);
    });
  }, [moduleImport, extractor]);

  const getLazyValue = useCallback(() => {
    if (!isLoaded || !lazyModuleRef.current) {
      return;
    }
    return lazyModuleRef.current;
  }, [isLoaded]);

  return {isLoaded, getLazyValue};
}
